import freeTrialImage from "./assets/free-trial.png";
import proImage from "./assets/pro.png";
import businessImage from "./assets/business.png";
import specialImage from "./assets/special.png";
import exercise3 from "./assets/exercise3.png"
import exercise4 from "./assets/exercise4.png"
import exercise2 from "./assets/exercise2.png"
import exercise1 from "./assets/exercise1.png"
import exercise5 from "./assets/exercise5.png"
import exercise6 from "./assets/exercise6.png"
import exercise7 from "./assets/exercise7.png"
import exercise8 from "./assets/exercise8.png"
import exercise9 from "./assets/exercise9.png"
import exercise10 from "./assets/exercise10.png"

console.log("Image URL:", freeTrialImage);

// Gif-Section
document.addEventListener("DOMContentLoaded", function () {
    // Constants
    const bookData = [
        {
            id: 1,
            bookName: "12th Maths Vol. 1",
            bookGroupName: "twelfthMathsVol1",
            chapters: [
                {
                    id: 101,
                    chapterName: "Complex Numbers",
                    exercises: [
                        {
                            id: 1001,
                            exerciseName: "Exercise: 2.1(2)",
                            exerciseLink: "https://app.robogebra.ai/public/solution/026433",
                            gifSrc: exercise1
                        },
                    ]
                },
                {
                    id: 102,
                    chapterName: "Two Dimensional Analytical Geometry-II",
                    exercises: [
                        {
                            id: 1002,
                            exerciseName: "Example:5.40",
                            exerciseLink: "https://app.robogebra.ai/public/solution/773912",
                            gifSrc: exercise2
                        },
                    ]
                },
                {
                    id: 103,
                    chapterName: "Applications of Vector Algebra",
                    exercises: [
                        {
                            id: 1003,
                            exerciseName: "Exercise: 6.1(1)",
                            exerciseLink: "https://app.robogebra.ai/public/solution/936395",
                            gifSrc: exercise3
                        },
                    ]
                },
                {
                    id: 104,
                    chapterName: "Applications of Vector Algebra",
                    exercises: [
                        {
                            id: 1004,
                            exerciseName: "Exercise: 6.1(2)",
                            exerciseLink: "https://app.robogebra.ai/public/solution/410765",
                            gifSrc: exercise4
                        },
                    ]
                },
                {
                    id: 105,
                    chapterName: "Applications of Vector Algebra",
                    exercises: [
                        {
                            id: 1005,
                            exerciseName: "Exercise: 6.1(4)",
                            exerciseLink: "https://app.robogebra.ai/public/solution/647428",
                            gifSrc: exercise5
                        },
                    ]
                }
            ]
        },
        {
            id: 2,
            bookName: "12th Maths Vol. 2",
            bookGroupName: "twelfthMathsVol2",
            chapters: [
                {
                    id: 201,
                    chapterName: "Applications of Differential Calculus",
                    exercises: [
                        {
                            id: 2001,
                            exerciseName: "Exercise: 7.1(7)",
                            exerciseLink: "https://app.robogebra.ai/public/solution/062797",
                            gifSrc: exercise6
                        },
                    ]
                },
                {
                    id: 202,
                    chapterName: "Applications of Differential Calculus",
                    exercises: [
                        {
                            id: 2002,
                            exerciseName: "Example:7.62",
                            exerciseLink: "https://app.robogebra.ai/public/solution/441456",
                            gifSrc: exercise7
                        },
                    ]
                },
                {
                    id: 203,
                    chapterName: "Applications of Integration",
                    exercises: [
                        {
                            id: 2003,
                            exerciseName: "Exercise: 9.1(1)",
                            exerciseLink: "https://app.robogebra.ai/public/solution/508938",
                            gifSrc: exercise8
                        },
                    ]
                },
                {
                    id: 204,
                    chapterName: "Applications of Integration",
                    exercises: [
                        {
                            id: 2004,
                            exerciseName: "Example:9.54",
                            exerciseLink: "https://app.robogebra.ai/public/solution/637284",
                            gifSrc: exercise9
                        },
                    ]
                },
                {
                    id: 205,
                    chapterName: "Probability Distributions",
                    exercises: [
                        {
                            id: 2005,
                            exerciseName: "Example:11.8",
                            exerciseLink: "https://app.robogebra.ai/public/solution/903271",
                            gifSrc: exercise10
                        },
                    ]
                }
            ]
        }
    ];

    const gifCache = {};

    /*To reload gifs prior for smooth rendering without delay*/
    function preloadGifs() {
        bookData.forEach(book => {
            book.chapters.forEach(chapter => {
                chapter.exercises.forEach(exercise => {
                    if (!gifCache[exercise.gifSrc]) {
                        const img = new Image();
                        gifCache[exercise.gifSrc] = img;
                        img.src = exercise.gifSrc;
                        img.onerror = () => console.warn("Failed to preload:", exercise.gifSrc);
                        img.fetchPriority = "high";
                    }
                });
            });
        });
    }

    // DOM Elements
    const elements = {
        bookSelectButtons: document.querySelectorAll(".book-select-btn"),
        exerciseContainer: document.getElementById("exerciseContainer"),
        gifDisplay: document.getElementById("gifDisplay"),
        overlay: document.getElementById("overlay"),
        seeMoreBtn: document.getElementById("text"),
        gifContainer: document.querySelector(".gif-container")
    };

    // State
    let activeLink = "https://app.robogebra.ai/public/solution/026433";

    // Helper Functions
    const clearActiveStates = () => {
        document.querySelectorAll(".exercise-btn").forEach(btn => btn.classList.remove("active"));
        document.querySelectorAll(".chapter-section").forEach(section => section.classList.remove("active"));
        document.querySelectorAll(".chapter-title").forEach(title => title.classList.remove("active"));
    };

    const setActiveStates = (element, chapterSection, chapterTitle) => {
        element.classList.add("active");
        chapterSection.classList.add("active");
        chapterTitle.classList.add("active");
    };

    // Event Handlers
    const handleGifContainerHover = (show) => {
        elements.overlay.style.display = show ? "block" : "none";
    };

    const handleSeeMoreClick = () => {
        //showComingSoonModal();

        if (activeLink !== "#") {
            window.open(activeLink, "_blank");
        }
    };

    const handleExerciseClick = (event) => {
        if (event.target.classList.contains("exercise-btn")) {
            const exerciseButton = event.target;
            activeLink = exerciseButton.dataset.link;
            elements.gifDisplay.src = exerciseButton.dataset.gif;
            elements.gifDisplay.style.display = "block";

            clearActiveStates();

            const chapterSection = exerciseButton.closest(".chapter-section");
            const chapterTitle = chapterSection.querySelector(".chapter-title");
            setActiveStates(exerciseButton, chapterSection, chapterTitle);
        }
    };

    const handleBookSelect = (event) => {
        const button = event.currentTarget;
        elements.bookSelectButtons.forEach(btn => btn.classList.remove("active"));
        button.classList.add("active");
        renderExercises(button.dataset.group);
    };

    const handleChapterClick = (event) => {
        if (event.target.classList.contains("chapter-title")) {
            const chapterTitle = event.target;
            const chapterSection = chapterTitle.closest(".chapter-section");
            const firstExercise = chapterSection.querySelector(".exercise-btn");

            if (firstExercise) {
                activeLink = firstExercise.dataset.link;
                elements.gifDisplay.src = firstExercise.dataset.gif;
                elements.gifDisplay.style.display = "block";

                clearActiveStates();
                setActiveStates(firstExercise, chapterSection, chapterTitle);
            }
        }
    };

    // Render Functions
    function createExerciseButton(exercise) {
        const exerciseBtn = document.createElement("button");
        exerciseBtn.className = "exercise-btn";
        exerciseBtn.textContent = exercise.exerciseName;
        exerciseBtn.dataset.link = exercise.exerciseLink;
        exerciseBtn.dataset.gif = exercise.gifSrc;
        exerciseBtn.setAttribute("aria-label", `View ${exercise.exerciseName} solution`);
        return exerciseBtn;
    }

    function createChapterSection(chapter) {
        const chapterDiv = document.createElement("div");
        chapterDiv.className = "chapter-section";
        chapterDiv.setAttribute("aria-labelledby", `chapter-${chapter.id}`);

        const chapterTitle = document.createElement("h4");
        chapterTitle.id = `chapter-${chapter.id}`;
        chapterTitle.textContent = chapter.chapterName;
        chapterTitle.className = "chapter-title";
        chapterDiv.appendChild(chapterTitle);
        chapterTitle.addEventListener("click", handleChapterClick);

        chapter.exercises.forEach(exercise => {
            const exerciseDiv = document.createElement("div");
            exerciseDiv.className = "exercise-item";
            exerciseDiv.appendChild(createExerciseButton(exercise));
            chapterDiv.appendChild(exerciseDiv);
        });

        return chapterDiv;
    }

    function renderExercises(groupId) {
        elements.exerciseContainer.innerHTML = "";
        const selectedBook = bookData.find(book => book.bookGroupName === groupId);

        if (!selectedBook) {
            elements.exerciseContainer.innerHTML = "<p>No exercises available for this book.</p>";
            return;
        }

        const fragment = document.createDocumentFragment();
        let firstChapterSection = null;
        let firstChapterTitle = null;
        let firstExerciseBtn = null;

        selectedBook.chapters.forEach((chapter, index) => {
            const chapterSection = createChapterSection(chapter);
            fragment.appendChild(chapterSection);

            // Store references to the first chapter's elements
            if (index === 0 && chapter.exercises.length > 0) {
                firstChapterSection = chapterSection;
                firstChapterTitle = chapterSection.querySelector(".chapter-title");
                firstExerciseBtn = chapterSection.querySelector(".exercise-btn");
            }
        });

        elements.exerciseContainer.appendChild(fragment);

        // Activate first exercise if available
        if (firstChapterSection && firstChapterTitle && firstExerciseBtn) {
            const firstExercise = selectedBook.chapters[0].exercises[0];
            activeLink = firstExercise.exerciseLink;
            elements.gifDisplay.src = firstExercise.gifSrc;
            elements.gifDisplay.style.display = "block";

            clearActiveStates();
            setActiveStates(firstExerciseBtn, firstChapterSection, firstChapterTitle);
        }
    }

    const gifContainer = elements.gifContainer;
    if(!gifContainer) return;
    gifContainer.addEventListener("mouseenter", () => handleGifContainerHover(true));
    gifContainer.addEventListener("mouseleave", () => handleGifContainerHover(false));
    gifContainer.addEventListener("focusin", () => handleGifContainerHover(true));
    gifContainer.addEventListener("focusout", () => handleGifContainerHover(false));

    elements.seeMoreBtn.addEventListener("click", handleSeeMoreClick);
    elements.exerciseContainer.addEventListener("click", handleExerciseClick);

    elements.bookSelectButtons.forEach(button => {
        button.addEventListener("click", handleBookSelect);
    });
    preloadGifs()
    renderExercises("twelfthMathsVol1");
});

//navbar-overlay-menu
document.addEventListener("DOMContentLoaded", function () {
    const menuIcon = document.getElementById('menuIcon');
    if (menuIcon) {
        menuIcon.addEventListener('click', toggleMenu);
    }

    const overlayMenuIcon = document.getElementById('overlayMenu');
    if (overlayMenuIcon) {
        overlayMenuIcon.addEventListener('click', onOverlayMenuClick);
    }

    function toggleMenu() {
        overlayMenuIcon.classList.toggle('open');
        if (overlayMenuIcon.classList.contains('open')) {
            menuIcon.classList.remove('fa-bars');
            menuIcon.classList.add('fa-times');
        } else {
            menuIcon.classList.remove('fa-times');
            menuIcon.classList.add('fa-bars');
        }
    }

    function onOverlayMenuClick() {
        overlayMenuIcon.classList.toggle('open');
        menuIcon.classList.remove('fa-times');
        menuIcon.classList.add('fa-bars');
    }
});

//scroll-top-fuctionality
document.addEventListener("DOMContentLoaded", function () {
    const backToTopButton = document.getElementById("scrollTopBtn");

    window.addEventListener("scroll", () => {
        if (window.scrollY > window.innerHeight) {
            backToTopButton.style.display = "block";
        } else {
            backToTopButton.style.display = "none";
        }
    });

    if (backToTopButton) {
        backToTopButton.addEventListener("click", () => {
            window.scrollTo({top: 0, behavior: "smooth"});
        });
    }
});

// Pricing-Section

const pricingData = [
    // 12th TN Maths Plans and Features
    {
        id: 4,
        name: "Basic Plan",
        pricePerDay: 20,
        image: proImage,
        groupId: "twelfthTNStateMaths",
        type: "plan",
        features: [
            "AI Smart learning helper",
            "Chapter-end quizzes",
            "Important question organizer",
            "Schedule study alerts"
        ]
    },
    {
        id: 5,
        name: "Explore Feature",
        pricePerDay: 10,
        image: businessImage,
        groupId: "twelfthTNStateMaths",
        type: "feature",
        features: [
            "AI Interactive practice sheets",
            "AI Dynamic concept visuals"
        ]
    },
    {
        id: 6,
        name: "Voice Tutor",
        pricePerDay: 20,
        image: specialImage,
        groupId: "twelfthTNStateMaths",
        type: "feature",
        features: [
            "Audio-based AI guidance"
        ]
    },
    // 12th Maths Plans and Features
    {
        id: 7,
        name: "Basic Plan",
        pricePerDay: 27,
        image: proImage,
        groupId: "twelfthMaths",
        type: "plan",
        features: [
            "AI Smart learning helper",
            "Chapter-end quizzes",
            "Important question organizer",
            "Schedule study alerts"
        ]
    },
    {
        id: 8,
        name: "Explore Feature",
        pricePerDay: 17,
        image: businessImage,
        groupId: "twelfthMaths",
        type: "feature",
        features: [
            "AI Interactive practice sheets",
            "AI Dynamic concept visuals"
        ]
    },
    {
        id: 9,
        name: "Voice Tutor",
        pricePerDay: 26,
        image: specialImage,
        groupId: "twelfthMaths",
        type: "feature",
        features: [
            "Audio-based AI guidance"
        ]
    }
];

function renderPricing(group) {
    const planCards = document.getElementById("planCards");
    const featureCards = document.getElementById("featureCards");

    if (!planCards || !featureCards) return;

    planCards.innerHTML = "";
    featureCards.innerHTML = "";

    const filteredData = pricingData.filter(item => item.groupId === group);

    if (filteredData.length === 0) {
        planCards.innerHTML = `<p class="text-center">No pricing available for this group.</p>`;
        return;
    }

    // Separate plans and features
    const plans = filteredData.filter(item => item.type === "plan");
    const features = filteredData.filter(item => item.type === "feature");

    // Render plans
    plans.forEach(item => {
        const planCard = createPricingCard(item);
        planCards.appendChild(planCard);
    });

    // Render features
    features.forEach(item => {
        const featureCard = createPricingCard(item, true);
        featureCards.appendChild(featureCard);
    });

    // Update total amount and states
    updateTotalAmount();
    updateFeaturesState();
    updatePaymentButtonState();
}

function createPricingCard(item, isFeature = false) {
    const pricingCard = document.createElement("div");
    pricingCard.className = `pricing-card ${isFeature ? 'feature-card' : 'plan-card'}`;

    const cardHeader = document.createElement("div");
    cardHeader.className = "card-header";

    const titleSection = document.createElement("div");
    titleSection.className = "title-section";

    const title = document.createElement("h4");
    title.textContent = item.name;
    titleSection.appendChild(title);

    const priceDetail = document.createElement("div");
    priceDetail.className = "price-detail";
    // Calculate total price based on current duration
    const totalPrice = Math.round(item.pricePerDay * currentDuration);
    priceDetail.textContent = `Price: ${item.pricePerDay} INR / Day`;
    titleSection.appendChild(priceDetail);

    cardHeader.appendChild(titleSection);

    const selectIcon = document.createElement("div");
    selectIcon.className = "plan-unselect-icon";
    cardHeader.appendChild(selectIcon);

    pricingCard.appendChild(cardHeader);

    const cardBody = document.createElement("div");
    cardBody.className = "card-body";

    const features = document.createElement("div");
    features.className = "features";

    item.features.forEach(feature => {
        const featureItem = document.createElement("div");
        featureItem.className = "feature-item";

        const checkmark = document.createElement("span");
        checkmark.className = "checkmark";
        checkmark.textContent = "✓";

        const featureText = document.createElement("span");
        featureText.textContent = feature;

        featureItem.appendChild(checkmark);
        featureItem.appendChild(featureText);
        features.appendChild(featureItem);
    });

    cardBody.appendChild(features);
    pricingCard.appendChild(cardBody);

    // Add click handler for selection
    pricingCard.addEventListener('click', function() {
        if (isFeature) {
            // Features can only be selected if a plan is selected
            if (!selectedPlan) return;

            // Toggle feature selection
            const isCurrentlySelected = this.classList.contains('selected');

            if (isCurrentlySelected) {
                // Deselect feature
                this.classList.remove('selected');
                selectIcon.className = 'plan-unselect-icon';
                selectIcon.innerHTML = '';
                selectedFeatures = selectedFeatures.filter(f => f.id !== item.id);
            } else {
                // Select feature
                this.classList.add('selected');
                selectIcon.className = 'plan-icon';
                selectIcon.innerHTML = '<svg-icon>✓</svg-icon>';
                selectedFeatures.push(item);
            }
        } else {
            // Plan selection (toggle selection)
            const isCurrentlySelected = this.classList.contains('selected');

            if (isCurrentlySelected) {
                // Deselect current plan
                this.classList.remove('selected');
                selectIcon.className = 'plan-unselect-icon';
                selectIcon.innerHTML = '';
                selectedPlan = null;
            } else {
                // First deselect any currently selected plan
                document.querySelectorAll('#planCards .pricing-card').forEach(card => {
                    card.classList.remove('selected');
                    const icon = card.querySelector('.plan-unselect-icon, .plan-icon');
                    if (icon) {
                        icon.className = 'plan-unselect-icon';
                        icon.innerHTML = '';
                    }
                });

                // Select this plan
                this.classList.add('selected');
                selectIcon.className = 'plan-icon';
                selectIcon.innerHTML = '<svg-icon>✓</svg-icon>';
                selectedPlan = item;
            }

            // Update features state when plan selection changes
            updateFeaturesState();
        }

        // Update total amount
        updateTotalAmount();
    });

    return pricingCard;
}

// Global variables for pricing
let currentDuration = 30;
let currentBookGroup = "twelfthTNStateMaths";
let selectedPlan = null;
let selectedFeatures = [];

// Calculate total amount
function updateTotalAmount() {
    let total = 0;

    if (selectedPlan) {
        total += selectedPlan.pricePerDay * currentDuration;
    }

    selectedFeatures.forEach(feature => {
        total += feature.pricePerDay * currentDuration;
    });

    const totalElement = document.getElementById('totalAmount');
    if (totalElement) {
        totalElement.textContent = `₹${Math.round(total)}`;
    }

    // Update payment button state
    updatePaymentButtonState();
}

// Update payment button state
function updatePaymentButtonState() {
    const paymentButton = document.querySelector('.continue-btn');
    const hasSelection = selectedPlan || selectedFeatures.length > 0;

    if (paymentButton) {
        paymentButton.disabled = !hasSelection;
    }
}

// Update features section state
function updateFeaturesState() {
    const featureCards = document.querySelectorAll('#featureCards .pricing-card');
    const featureGroup = document.getElementById('featureGroup');

    const planSelected = selectedPlan !== null;

    featureCards.forEach(card => {
        if (planSelected) {
            card.classList.remove('disabled');
            card.style.pointerEvents = 'auto';
            card.style.opacity = '1';
        } else {
            card.classList.add('disabled');
            card.classList.remove('selected');
            card.style.pointerEvents = 'none';
            card.style.opacity = '0.5';

            // Reset icon
            const icon = card.querySelector('.plan-icon, .plan-unselect-icon');
            if (icon) {
                icon.className = 'plan-unselect-icon';
                icon.innerHTML = '';
            }
        }
    });

    // Update feature group title based on plan selection
    const featureTitle = featureGroup?.querySelector('.group-title');
    if (featureTitle) {
        if (planSelected) {
            featureTitle.innerHTML = 'Feature add-ons: <span class="feature-add-on-note">(Add-ons available)</span>';
        } else {
            featureTitle.innerHTML = 'Feature add-ons: <span class="feature-add-on-note">(Add-ons will be available after you select a plan).</span>';
        }
    }

    // Clear selected features if no plan
    if (!planSelected) {
        selectedFeatures = [];
        updateTotalAmount();
    }
}

// Calculate and display plan dates
function updatePlanDates() {
    const today = new Date();
    const endDate = new Date(today);
    endDate.setDate(today.getDate() + currentDuration);

    const formatDate = (date) => {
        return date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    const startDateElement = document.getElementById('planStartDate');
    const endDateElement = document.getElementById('planEndDate');

    if (startDateElement) {
        startDateElement.textContent = formatDate(today);
    }

    if (endDateElement) {
        endDateElement.textContent = formatDate(endDate);
    }
}

// Calculate slider fill percentage
function getSliderFillPercentage() {
    const min = 7;
    const max = 180;
    return ((currentDuration - min) / (max - min)) * 100;
}

// Update slider fill
function updateSliderFill() {
    const slider = document.getElementById('durationSlider');
    if (slider) {
        const fillPercentage = getSliderFillPercentage();
        slider.style.setProperty('--slider-fill', fillPercentage + '%');
    }
}

// Handle duration change
function onDurationChange(newDuration) {
    const duration = parseInt(newDuration);

    // Enforce minimum 7-day restriction
    if (duration < 7) {
        currentDuration = 7;
        const durationSlider = document.getElementById('durationSlider');
        if (durationSlider) {
            durationSlider.value = 7;
        }
    } else {
        currentDuration = duration;
    }

    // Update display elements
    const durationDisplay = document.getElementById('durationDisplay');

    if (durationDisplay) {
        durationDisplay.textContent = `${currentDuration} Days`;
    }

    updateSliderFill();
    updatePlanDates();

    // Recalculate pricing based on new duration
    renderPricing(currentBookGroup);
}

// Handle book group change
function onBookChange(newBookGroup) {
    currentBookGroup = newBookGroup;

    // Reset selections when changing book
    selectedPlan = null;
    selectedFeatures = [];

    renderPricing(currentBookGroup);
}

document.addEventListener("DOMContentLoaded", () => {
    const defaultPricingGroup = "twelfthTNStateMaths";
    currentBookGroup = defaultPricingGroup;

    // Initialize duration slider
    const durationSlider = document.getElementById('durationSlider');
    if (durationSlider) {
        durationSlider.value = currentDuration;
        updateSliderFill();

        durationSlider.addEventListener('input', function() {
            onDurationChange(this.value);
        });
    }

    // Initialize book dropdown
    const bookDropdown = document.getElementById('bookDropdown');
    if (bookDropdown) {
        bookDropdown.value = defaultPricingGroup;

        bookDropdown.addEventListener('change', function() {
            onBookChange(this.value);
        });
    }

    // Initial render
    renderPricing(defaultPricingGroup);

    // Initialize display values
    onDurationChange(currentDuration);
    updatePlanDates();
});


$(document).ready(function () {

    const $submitBtn = $("#sendMail");
    const $requiredFields = $(".required");
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;


    function toggleSubmit() {
        const allFilled = $requiredFields.toArray().every(el => $(el).val().trim() !== "");
        $submitBtn.prop("disabled", !allFilled);
    }

    function validateField($field) {
        const value = $field.val().trim();
        const id = $field.attr("id");

        $(`#${id}-error, #${id}-length-error, #contact-required-error, #contact-digit-error`).hide();
        $field.removeClass("invalid");

        if (id === "contactNo") {
            if (value === "") {
                $("#contact-required-error").show();
                $field.addClass("invalid");
            } else if (!/^\d{10}$/.test(value)) {
                $("#contact-digit-error").show();
                $field.addClass("invalid");
            }

        } else if (id === "name") {
            if (value === "") {
                $("#name-error").show();
                $field.addClass("invalid");
            } else if (value.length < 3) {
                $("#name-length-error").show();
                $field.addClass("invalid");
            }

        } else if (id === "email") {
            const $errorDiv = $("#email-error");
            $errorDiv.hide().text("");
            $field.removeClass("invalid");

            if (value === "") {
                $errorDiv.text("Email Address is required").show();
                $field.addClass("invalid");
            } else if (!emailRegex.test(value)) {
                $errorDiv.text("Please enter a valid email address").show();
                $field.addClass("invalid");
            }
        } else {
            const $error = $(`#${id}-error`);
            if (value === "") {
                $error.text(`${$field.prev("label").text()} is required`).show();
                $field.addClass("invalid");
            }
        }
    }

    $requiredFields.on("input", function () {
        validateField($(this));
        toggleSubmit();
    });

    $requiredFields.on("blur", function () {
        validateField($(this));
    });
    toggleSubmit();

    $submitBtn.click(function (e) {
        e.preventDefault();

        let hasError = false;

        $requiredFields.each(function () {
            const $field = $(this);
            if ($field.val().trim() === "") {
                validateField($field);
                hasError = true;
            }
        });

        if (hasError) return;
        const name = $('#name').val();
        const email = $('#email').val();
        const designation = $('#designation').val();
        const contactNo = $('#contactNo').val();
        const requirement = $('#requirement').val();

        $('form').trigger("reset");

        $submitBtn.prop("disabled", true);

        window.location.href = `mailto:robogebra.ai@gmail.com?subject=Robogebra Contact Form By ${name} (${email})&body=${requirement}`;
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const buttons = document.querySelectorAll('.abt-see-more-btn');

    buttons.forEach(button => {
        button.addEventListener('click', function () {
            const container = this.closest('.team-container');

            // Toggle expansion
            container.classList.toggle('expanded');

            // Optional: Toggle button text
            if (container.classList.contains('expanded')) {
                this.textContent = 'See less...';
            } else {
                this.textContent = 'See more...';
            }
        });
    });

    // Collapse when clicking outside
    document.addEventListener('click', function (event) {
        const expandedContainers = document.querySelectorAll('.team-container.expanded');

        expandedContainers.forEach(container => {
            if (!container.contains(event.target)) {
                container.classList.remove('expanded');

                // Reset the button text to "See more"
                const btn = container.querySelector('.abt-see-more-btn');
                if (btn) btn.textContent = 'See more...';
            }
        });
    });
});

// About-us section logic
document.addEventListener("DOMContentLoaded", () => {
    const topBio = document.getElementById("top-bio");
    const cards = document.querySelectorAll(".team-card");

    if (!topBio || cards.length === 0) return;

    // Attach click listeners to all cards
    cards.forEach(card => {
        card.addEventListener("click", () => {
            // Remove 'active' class from all cards
            cards.forEach(c => c.classList.remove("active"));
            // Add 'active' class to clicked card
            card.classList.add("active");

            // Show the bio
            const bio = card.getAttribute("data-bio");
            topBio.innerText = bio;
            topBio.classList.add("visible");
        });
    });
    // Select the first card by default
    cards[0].click();
});

// Audio Player Functionality
document.addEventListener('DOMContentLoaded', function() {
    const audioPlayer = document.getElementById('audioPlayer');
    const playPauseBtn = document.getElementById('playPauseBtn');
    const playIcon = playPauseBtn.querySelector('.play-icon');
    const pauseIcon = playPauseBtn.querySelector('.pause-icon');
    const progressFill = document.getElementById('progressFill');
    const progressThumb = document.getElementById('progressThumb');
    const progressBar = document.querySelector('.progress-bar');
    const currentTimeDisplay = document.getElementById('currentTime');

    if (!audioPlayer) return;

    let isDragging = false;

    // Format time helper function
    function formatTime(seconds) {
        const mins = Math.floor(seconds / 60);
        const secs = Math.floor(seconds % 60);
        return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    }

    // Update progress bar
    function updateProgress() {
        if (isDragging) return;

        const duration = audioPlayer.duration || 0;
        const currentTime = audioPlayer.currentTime || 0;
        const progressPercent = duration ? (currentTime / duration) * 100 : 0;

        progressFill.style.width = progressPercent + '%';
        progressThumb.style.left = progressPercent + '%';
        currentTimeDisplay.textContent = formatTime(currentTime);
    }

    // Play/Pause functionality
    playPauseBtn.addEventListener('click', function() {
        if (audioPlayer.paused) {
            audioPlayer.play().then(() => {
                playIcon.style.display = 'none';
                pauseIcon.style.display = 'block';
            }).catch(error => {
                console.error('Error playing audio:', error);
            });
        } else {
            audioPlayer.pause();
            playIcon.style.display = 'block';
            pauseIcon.style.display = 'none';
        }
    });

    // Progress bar click/drag functionality
    function updateAudioTime(event) {
        const progressBarRect = progressBar.getBoundingClientRect();
        const clickX = event.clientX - progressBarRect.left;
        const progressBarWidth = progressBarRect.width;
        const clickPercent = (clickX / progressBarWidth) * 100;
        const newTime = (clickPercent / 100) * audioPlayer.duration;

        if (isFinite(newTime)) {
            audioPlayer.currentTime = newTime;
            updateProgress();
        }
    }

    progressBar.addEventListener('click', updateAudioTime);

    // Drag functionality for progress thumb
    progressThumb.addEventListener('mousedown', function(e) {
        isDragging = true;
        e.preventDefault();
    });

    document.addEventListener('mousemove', function(e) {
        if (isDragging) {
            updateAudioTime(e);
        }
    });

    document.addEventListener('mouseup', function() {
        isDragging = false;
    });

    // Audio event listeners
    audioPlayer.addEventListener('timeupdate', updateProgress);

    audioPlayer.addEventListener('loadedmetadata', function() {
        currentTimeDisplay.textContent = formatTime(0);
        updateProgress();
    });

    audioPlayer.addEventListener('ended', function() {
        playIcon.style.display = 'block';
        pauseIcon.style.display = 'none';
        progressFill.style.width = '0%';
        progressThumb.style.left = '0%';
        currentTimeDisplay.textContent = formatTime(0);
    });

    // Initialize display
    currentTimeDisplay.textContent = '03:00'; // Default duration as shown in image
});

// Coming Soon Modal Functions - Global scope
window.showComingSoonModal = function() {
    const modal = document.getElementById('comingSoonModal');
    if (modal) {
        modal.style.display = 'block';
        document.body.style.overflow = 'hidden';
    }
}

window.hideComingSoonModal = function() {
    const modal = document.getElementById('comingSoonModal');
    if (modal) {
        modal.style.display = 'none';
        document.body.style.overflow = 'auto';
    }
}

// Close modal when clicking outside of it
document.addEventListener('DOMContentLoaded', function() {
    const modal = document.getElementById('comingSoonModal');
    if (modal) {
        modal.addEventListener('click', function(event) {
            if (event.target === modal) {
                hideComingSoonModal();
            }
        });
    }
});
